import AXIOS from '@/axios-instance';

export default {

  linkQuestionsToElement(uuidModel, elementId, qid, friendlyName) {
    const config = { headers: {'Content-Type': 'application/json'} };
    return AXIOS.post("/px/bpmn/" + uuidModel + "/element/" + elementId + "/question/"+ qid, friendlyName, config);
  },
  removeQuestionFromElement(uuidModel, elementId, qid) {
    return AXIOS.delete("/px/bpmn/" + uuidModel + "/element/" + elementId + "/question/"+ qid);
  },
  retrievePxQuestionsForElement(uuid, elementId){
    return AXIOS.get("/px/bpmn/" + uuid + "/element/" + elementId);
  },
  retrieveRolePxQuestions(){
    return AXIOS.get("/px/question/type/ROLE");
  },
  retrieveUserPxQuestions(){
    return AXIOS.get("/px/question/type/USER");
  },
  retrieveActivityPxQuestions(){
    return AXIOS.get("/px/question/type/ACTIVITY");
  },
  retrieveProcessPxQuestions(){
    return AXIOS.get("/px/question/type/PROCESS");
  },
  retrievePxIwakQuestionsForElement(element){
      return AXIOS.get("/question/element/"+element);
  },
  retrievePxIwakQuestionsForElementWithoutSelected(element, uuid){
    return AXIOS.get("/question/element/"+element+"/uuid/"+uuid);
}
}